import React from 'react';
import { clsx } from 'clsx';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'success' | 'warning' | 'error' | 'info' | 'outline';
  size?: 'sm' | 'md';
  className?: string;
}

const variantStyles: Record<string, React.CSSProperties> = {
  default: { backgroundColor: 'var(--theme-primary-background)', color: 'var(--theme-primary)' },
  success: { backgroundColor: 'var(--theme-success-background)', color: 'var(--theme-success-color)' },
  warning: { backgroundColor: 'var(--theme-warning-background)', color: 'var(--theme-warning-color)' },
  error: { backgroundColor: 'var(--theme-error-background)', color: 'var(--theme-error-color)' },
  info: { backgroundColor: 'var(--theme-info-background)', color: 'var(--theme-info-color)' },
  outline: { backgroundColor: 'transparent', color: 'var(--theme-muted-text)', border: '1px solid var(--theme-border)' },
};

export const Badge: React.FC<BadgeProps> = ({ children, variant = 'default', size = 'sm', className }) => {
  return (
    <span
      className={clsx(
        'inline-flex items-center font-medium rounded-full',
        { 'px-2 py-0.5 text-xs': size === 'sm', 'px-2.5 py-1 text-sm': size === 'md' },
        className
      )}
      style={variantStyles[variant]}
    >
      {children}
    </span>
  );
};
